import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const resource = "/admin/system_setting/tax_codes";

export default {
  getListOfTaxCodes(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getTax(id) {
    return Repository.get(`${resource}/${id}`)
  },
  createTaxCode(payload) {
    return Repository.post(`${resource}`, payload)
  },
  deleteTaxCode(id) {
    return Repository.delete(`${resource}/${id}`)
  },
  updateTaxCode(id, payload) {
    return Repository.put(`${resource}/${id}`, payload)
  }
};
